import { Page, LinkButton } from '@/components';
import { Flex, Heading } from '@blockanalitica/ui';
import TopKpis from './TopKpis';
import OverviewGraphTabs from './OverviewGraphTabs';
import MarketsTable from './MarketsTable';

export default function NetworkPage() {
  return (
    <Page>
      <TopKpis />
      <OverviewGraphTabs />
      <Flex flexDirection="column" gap="s">
        <Flex gap="s" justifyContent="space-between" alignItems="center">
          <Heading size="3">Top Markets</Heading>
          <LinkButton to="markets" variant="secondary">
            view all
          </LinkButton>
        </Flex>
        <MarketsTable p={1} p_size={5} />
      </Flex>
    </Page>
  );
}
